export default {
  listPaymentMethods: [],
  paymentMethods: {
    descricao: '',
    ativo: true,
  },
}
